import { request } from '../request';

const BodyMeasurementApi = {
  /**
   * 射频维度测量，获取用户最新的测量结果
   */
  getLastMeasurement(serviceOrderId: string) {
    return request<GetLastMeasurementResponse>({
      path: '/pad/service/order/v1/body/measurement/latest',
      query: { serviceOrderId },
    });
  },
  /**
   * 射频维度测量，获取体围数值和图像相关接口
   */
  getMeasurementResult(serviceOrderId: string) {
    return request<GetMeasurementResultResponse>({
      path: '/pad/service/order/v1/body/measurement/result',
      query: { serviceOrderId },
    });
  },
  /**
   * 射频维度测量，保存体围数值和图像相关接口
   */
  saveMeasurementResult(params: SaveMeasurementResultParams) {
    return request<GetMeasurementResultResponse>({
      path: '/pad/service/order/v1/body/measurement/result',
      method: 'POST',
      data: params,
    });
  },
};

export default BodyMeasurementApi;
